export default "__VITE_ASSET__h0UF$Y4y__"